// Flow types automatically removed

import formStyles from '../styles/FormGeneral.scss';
export const ErrorMessage = ({ errors }) => {
    return errors ? <div className={formStyles.error}>{errors}</div> : null;
};
